import { get } from 'lodash';

import { FIELD_PATHS, GOVERNMENT_RETIREMENT_AGE } from '@funnels/constants';
import { AnyFormValues, FinancialSituation } from '@funnels/types';

import getAgeFromDOB from './getAgeFromDOB';

export default function canCoverLoanTerm(
  formValues: AnyFormValues,
  productPreferencesIndex: number,
  applicantIndex: number
) {
  /*
		For any applicant
			IF Min(Applicant Retirement Age, GOVERNMENT_RETIREMENT_AGE) - loan term <= applicantAge:
				go to exit-strategy
		For all Applicant
			IF Min(Applicant Retirement Age, GOVERNMENT_RETIREMENT_AGE) - loan term > applicantAge:
				redirect to the dashboard.
	*/

  const applicantId: string = get(formValues, FIELD_PATHS.APPLICANT_ID(applicantIndex));
  const applicantAge = Number(getAgeFromDOB(get(formValues, FIELD_PATHS.APPLICANT_DATE_OF_BIRTH(applicantIndex))));

  const financialSituation = get(formValues, FIELD_PATHS.FINANCIAL_SITUATIONS(), []).find(
    (financialSituation: FinancialSituation) =>
      get({ financialSituations: [financialSituation] }, FIELD_PATHS.FINANCIAL_SITUATION_APPLICANT_ID(0)) ===
      applicantId
  );

  const retirementAge = get(
    { financialSituations: [financialSituation] },
    FIELD_PATHS.FINANCIAL_SITUATION_RETIREMENTDETAILS_AGE(0),
    GOVERNMENT_RETIREMENT_AGE
  );
  const loanTerm = Number(get(formValues, FIELD_PATHS.PRODUCT_PREFERENCE_LOAN_TERM(productPreferencesIndex)));

  if (Math.abs(Math.min(retirementAge, GOVERNMENT_RETIREMENT_AGE) - loanTerm) > applicantAge) {
    return true;
  }
  return false;
}
